module.exports = __webpack_public_path__ + "assets/img/router_import.74947526.jpg";